import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { PostmethodService } from '../../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class SalesManagerModalService {

constructor(private ws: PostmethodService) { }

createProduct(request: any) {
  return this.ws.wsPost(request, environment.baseUrl + "/lead/assign/tc-sales-manager");
}

}
